import { nonEmptyStringValidator } from '@vista/omnichannel-components-domain';
import { Validator } from '@vista-digital/validator';
import { fieldDisplayTextValidatorSchema } from '../../types/field-display-text';
export const dateFieldDisplayTextValidator = Validator.object({
    label: fieldDisplayTextValidatorSchema.label,
    requiredMessage: fieldDisplayTextValidatorSchema.requiredMessage,
    formatMessage: fieldDisplayTextValidatorSchema.formatMessage,
    minAgeMessage: Validator.optional(nonEmptyStringValidator)
});
